import * as React from 'react';

import { SvgIcon } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';

import { ReactComponent as CrewIcon } from '../core/styles/icons/crew.svg';

interface ReportCategoryProps {
  category: string | null | undefined;
}

function CategoryIcon({ category }: ReportCategoryProps) {
  switch (category) {
    case 'Crew': return <CrewIcon />;
    default: return <FeedIcon />;
  }
}

function ReportCategoryIcon({ category }: ReportCategoryProps) {
  return (
    <SvgIcon>
      <CategoryIcon category={category} />
    </SvgIcon>
  );
}

export default ReportCategoryIcon;
